"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEE_SETTINGS_ID = void 0;
exports.FEE_SETTINGS_ID = '4BC50C9B0D8515D3EAAE1E74B29A95804346C491EE1A95BF25E4AAB854A6A651';
//# sourceMappingURL=FeeSettings.js.map